import React from 'react';
import { useAppDispatch } from 'store/hooks';
import { useParams } from 'react-router-dom';

import { reorderCourseModules } from 'store/course/actions';

import { useChangeOrder } from 'hooks/useChangeOrder';

import Modules from './Modules';

const ModulesContainer = ({
  modules,
  ...restProps
}: { modules: any } & Record<string, any>) => {
  const dispatch = useAppDispatch();

  const { id: courseId } = useParams();

  const _handleModuleDragEnd = (items: any) => {
    dispatch(
      reorderCourseModules({
        courseId,
        data: { modules: items },
      }),
    );
  };

  const {
    sensors,
    activeDragItem,
    onItemDragStart,
    onItemDragEnd,
    onItemDragOver,
  } = useChangeOrder({
    items: modules,
    namePrefix: 'modules',
    onItemDragEnd: _handleModuleDragEnd,
  });

  return (
    <Modules
      {...restProps}
      modules={modules}
      sensors={sensors}
      activeDragModule={activeDragItem}
      onModuleDragOver={onItemDragOver}
      onModuleDragStart={onItemDragStart}
      onModuleDragEnd={onItemDragEnd}
    />
  );
};

export default React.memo(ModulesContainer) as any;
